/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  index.tsx
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:31
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { Vue, Component, Prop } from 'vue-property-decorator'
import defaultSettings from '@/config/defaultSettings.ts'

@Component
export default class TheAuthCode extends Vue {
  @Prop({ default: 60 }) count!: number;
  @Prop({ default: '验证码' }) showText!: string
  public seconds = -1;
  public _timer: any = null;
  public loading = false;

  // created () {
  //   let cacheDate = window.localStorage.getItem(this._dateKey)
  //   if (cacheDate) {
  //     // @ts-ignore
  //     const diffSeconds = Math.round((new Date() - new Date(cacheDate)) / 1000)
  //     if (diffSeconds < this.count) {
  //       this.seconds = this.count - diffSeconds
  //       this.seconds > 0 && this.waitMoment()
  //     } else {
  //       this.seconds = -1
  //     }
  //   }
  // }

  get _key () {
    return `smsCodeSeconds_${this.$route.path}`
  }

  get _dateKey () {
    return `smsCodeSeconds_${this.$route.path}_date`
  }

  get text () {
    // 传送父组件显示信息
    let text = '请先获取验证码'
    if(this.seconds === -1){
      text = '请先获取验证码'
    }else if(this.seconds === 0){
      text = '短信验证码已失效，请重新获取'
    }else {
      text = '请输入验证码'
    }
    this.$emit('toastTextChange',this.seconds)
    return this.seconds === -1
      ? `获取${this.showText}`
      : (this.seconds === 0
        ? `重新获取${this.showText}`
        : `重新获取${this.showText}(${this.seconds}s)`)
  }

  get isDisabled () {
    return this.seconds !== 0 && this.seconds !== -1
  }

  click () {
    if (this.seconds > 0) return
    this.loading = true
    this.$emit('sendCode')
  }

  closeLoading () {
    this.loading = false
  }

  setTimer () {
    this.seconds = this.count
    window.localStorage.setItem(this._dateKey, new Date().toString())
    this.waitMoment()
  }

  waitMoment () {
    this._timer = setTimeout(() => {
      // @ts-ignore
      const diff = Math.round((new Date() - new Date(window.localStorage.getItem(this._dateKey))) / 1000)
      const seconds = this.count - diff
      this.seconds = seconds < 0 ? 0 : seconds
      if (this.seconds > 0) this.waitMoment()
    }, 1000)
  }

  render () {
    return (
      <van-button style={{ color: this.isDisabled ? '#8B8B8B' : defaultSettings.primaryColor, border: 'none' }} disabled={this.isDisabled} onClick={this.click.bind(this)}>{this.text}</van-button>
    )
  }
}
